import { elementDisplay, isElementVisible, mandatoryInput } from "../../../utils/elementControl";
import { DropdownItem } from "../../../components/ConfigPage/models/Config.interface";
import { translate } from "../../../utils/translateUtils";
import { setdefzeroval } from "../../../utils/inputValueFormat";

export function addServiceOrder(
    id:any,
) {
    let idnum = id.split("SPR");
    let temp = idnum[1].split("_");
    let NumberOfSO = temp[0];
    let NumberOfPage = temp[1];
    let i = 20;

    for (let a = NumberOfSO; a <= i; a++) {

        //Once found a division is hidden, it will show and break the loop to end the function
        if (!isElementVisible("#divSO" + a + "_" + NumberOfPage)) {
            mandatoryInput("#ddlSO" + a + "_" + NumberOfPage, true, "select");
            mandatoryInput("#txtSOPercent" + a + "_" + NumberOfPage, true, "text");
            elementDisplay("#divSO" + a + "_" + NumberOfPage, true, "div");
            break;
        }
    }
}


export function delServiceOrder(
    id:any,
    handleInputChange: (id: string, value?: any) => Promise<void>, 
) {
    let idnum = id.split("SPR");
    let temp = idnum[1].split("_");
    let NumberOfSO = temp[0];
    let NumberOfPage = temp[1];
    let i = 20;

    for (let a = i; a >= 0; a--) {

        //Prevent run function if there is only one division Service Order
        if (a == 1) {
            break;
        }

        //Once found a division is hidden, it will show and break the loop to end the function
        if (isElementVisible("#divSO" + a + "_" + NumberOfPage)) {

            //Reset all value in the following division per diem calculation
            mandatoryInput("#ddlSO" + a + "_" + NumberOfPage, false, "select");
            mandatoryInput("#txtSOPercent" + a + "_" + NumberOfPage, false, "text");
            handleInputChange("ddlSO" + a + "_" + NumberOfPage, "");
            handleInputChange("txtSOPercent" + a + "_" + NumberOfPage, "");
            elementDisplay("#divSO" + a + "_" + NumberOfPage, false, "div");
            break;
        }
    }
}


export function soReset(
    id:any,
    handleInputChange: (id: string, value?: any) => Promise<void>, 
) {
    let idnum = id.split("SO");
    let SOtype = idnum[1];
    let NumberOfPage = idnum[2];

    //Reset all service order field
    if (SOtype == 'Percentage') {

        const labelElement = document.querySelector<HTMLElement>(`#lblpercentage${NumberOfPage}`);
        if (labelElement) {
            labelElement.innerHTML = "%";
            labelElement.setAttribute("data-tag", "percentage");
        }

        for (let a = 20; a >= 0; a--) {
            handleInputChange("ddlSO" + a + "_" + NumberOfPage, "");
            handleInputChange("txtSOPercent" + a + "_" + NumberOfPage, "");
        }
    }

    //Reset all service order field
    if (SOtype == 'Amount') {

        const labelElement = document.querySelector<HTMLElement>(`#lblpercentage${NumberOfPage}`);
        if (labelElement) {
            labelElement.innerHTML = "Amount";
            labelElement.setAttribute("data-tag", "amount");
        }

        for (let a = 20; a >= 0; a--) {
            handleInputChange("ddlSO" + a + "_" + NumberOfPage, "");
            handleInputChange("txtSOPercent" + a + "_" + NumberOfPage, "");
        }
    }
}


//Function to check duplicate value in an array
export function checkForDuplicates(array:any[]) {
    //return new Set(array).size !== array.length

    let sortedArray = array.sort();

    let arrayDuplicate = [];

    for (let i = 0; i < sortedArray.length - 1; i++) {
        if (sortedArray[i + 1] == sortedArray[i]) {
            arrayDuplicate.push(sortedArray[i]);
        }
    }

    if (arrayDuplicate.length > 0) {
        return true;
    }
    else {
        return false;
    }
}

export function getServiceOrderValue(runningNumber:number, i:number, inputValues: { [key: string]: any | undefined }, tempServiceOrderObj:any = {}) {
    if (inputValues[`txtSOPercent${runningNumber}_${i}`] > 0) {

        let local_final_amount = 0.00;
        if (inputValues[`ddlVAT${i}`] == '1') {
            local_final_amount = parseFloat(inputValues[`txtClaimAmount${i}`] || "0") - parseFloat(inputValues[`hidden_VAT_Amount${i}`] || "0");
        } else {
            local_final_amount = parseFloat(inputValues[`txtClaimAmount${i}`] || "0");
        }

        tempServiceOrderObj.SOAmount1 = setdefzeroval((((parseFloat(inputValues[`txtSOPercent${runningNumber}_${i}`] || "0") * local_final_amount)) / 100).toString());
    } else {
        tempServiceOrderObj.SOAmount1 = '0';
    }
}

export function createSODropdownOption(response: any) {
    const dropdownItems: DropdownItem[] = response.filter((item: any) => item.id !== "" && item.id !== null).map((item: any) => {
        return {
            value: item.internal_order,
            label: translate(item.text),
        };
    });
    return Array.from(new Set(dropdownItems.map(item => JSON.stringify(item))))
        .map(str => JSON.parse(str) as DropdownItem);
}